<div class="operator-date-filter">
<button #trigger
		type="button"
		class="date-filter-btn"
		(click)="toggle()"
		[attr.aria-expanded]="open"
		aria-label="Open date filter">
	<span>{{ dateFilterLabel }}</span>
	<mat-icon>calendar_today</mat-icon>
</button>
<ng-container #pickerOutlet></ng-container>
<ng-template #panelTemplate>
<div class="date-picker-panel" role="dialog" aria-label="Choose a date range" (click)="$event.stopPropagation()">
	<div class="date-picker-presets">
		<button type="button"
				class="date-picker-preset"
				*ngFor="let item of presets"
				[class.date-picker-preset--active]="isSelectedPreset(item.value)"
				(click)="selectPreset(item.value)">
			{{ item.label }}
		</button>
	</div>

	<div class="date-picker-calendars">
		<mat-calendar #leftCalendar
					  [startAt]="leftMonth"
					  [selected]="selectedRange"
					  [maxDate]="maxSelectableDate"
					  [dateFilter]="selectableDateFilter"
					  (selectedChange)="onDateSelected($event)">
		</mat-calendar>
		<mat-calendar #rightCalendar
					  [startAt]="rightMonth"
					  [selected]="selectedRange"
					  [maxDate]="maxSelectableDate"
					  [dateFilter]="selectableDateFilter"
					  (selectedChange)="onDateSelected($event)">
		</mat-calendar>

		<div class="date-picker-actions">
			<button mat-button type="button" class="date-picker-clear" (click)="clear()">Clear</button>
			<button mat-flat-button type="button" class="date-picker-generate" (click)="generate()">Generate</button>
		</div>
	</div>
</div>
</ng-template>
</div>
